"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChromeTooltipBox = exports.InnerMaxHeight = exports.InnerMaxWidth = exports.OuterMaxHeight = exports.OuterMaxWidth = exports.BorderWidth = exports.Padding = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TabStyles_1 = require("../../styles/TabStyles");
exports.Padding = 8;
exports.BorderWidth = TabStyles_1.TabStyles.Sizing.BorderWidth;
exports.OuterMaxWidth = 250;
exports.OuterMaxHeight = 250;
exports.InnerMaxWidth = exports.OuterMaxWidth - 2 * (exports.Padding + exports.BorderWidth);
exports.InnerMaxHeight = exports.OuterMaxHeight - 2 * (exports.Padding + exports.BorderWidth);
var OuterStyle = {
    flexGrow: 0,
    padding: exports.Padding,
    borderWidth: exports.BorderWidth,
    borderStyle: 'solid',
    borderColor: TabStyles_1.TabStyles.Colors.L5,
    borderRadius: TabStyles_1.TabStyles.Sizing.BorderRadius,
    boxShadow: TabStyles_1.TabStyles.Shadow.Standard,
    backgroundColor: TabStyles_1.TabStyles.Colors.White,
};
// NOTE inner div handles content overflow so that scroll bars appear within padding of outer div
var InnerStyle = {
    maxWidth: exports.InnerMaxWidth,
    maxHeight: exports.InnerMaxHeight,
    overflowY: 'auto'
};
function ChromeTooltipBox(props) {
    return (React.createElement("div", { style: OuterStyle },
        React.createElement("div", { style: getInnerStyle(props.width) }, props.content)));
}
exports.ChromeTooltipBox = ChromeTooltipBox;
function getInnerStyle(width) {
    return tslib_1.__assign(tslib_1.__assign({}, InnerStyle), { width: width });
}
//# sourceMappingURL=ChromeTooltipBox.js.map